import type { ReactNode } from 'react';
import { SidebarGroupLabel } from '@kognitos/lattice';

/** Sidebar section heading. */
const SidebarGroupHeading = ({ children }: { children: ReactNode }) => (
  <SidebarGroupLabel className="app-sidebar-group-label relative !h-8 px-3 group-data-[collapsible=icon]:!mt-0 group-data-[collapsible=icon]:!opacity-100">
    <span className="truncate transition-opacity duration-150 group-data-[collapsible=icon]:opacity-0">
      {children}
    </span>
  </SidebarGroupLabel>
);

export default SidebarGroupHeading;
